import React from 'react'
import { connect } from 'react-redux'

export const PendingPayment = (props) => {
    return (
        <div>
            <div className="parent-width column centerItems centerContent parent-higth">
                <div className=" text-center text-bold text-fz-1-5">PAGO PENDIENTE</div>

            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({

})

const mapDispatchToProps = {

}

export default connect(mapStateToProps, mapDispatchToProps)(PendingPayment)
